import { css } from '@styled-system/css';
import { type FC } from 'react';
import Skeleton from 'react-loading-skeleton';

export interface StatCardProps {
  value: string;
  label: string;
  icon: string;
  loading?: boolean;
}

export const StatCard: FC<StatCardProps> = ({ value, label, icon, loading }) => {
  const cardStyles = css({
    bg: 'base.segBg', // #16171b
    border: '0.75px solid',
    borderColor: 'base.border', // #1e1f24
    borderRadius: 'lg', // 8px
    px: '1.3125rem', // 21px
    py: '0.8125rem', // 13px
    display: 'flex',
    flexDirection: 'column',
    gap: '0.375rem', // 6px
    height: '4.375rem', // 70px
    width: '15.625rem', // 250px
  });

  const valueStyles = css({
    fontSize: '1rem', // 16px
    fontWeight: 'bold',
    fontFamily: 'Manrope, sans-serif',
    color: 'font.primary', // #e6e6e9
    lineHeight: '1.07',
  });

  const labelStyles = css({
    fontSize: 'sm', // 11px
    fontWeight: 'medium',
    fontFamily: 'Manrope, sans-serif',
    color: 'font.lowkey', // #4f5055
    lineHeight: '1.07',
    whiteSpace: 'nowrap',
  });

  return (
    <div className={cardStyles}>
      <div className={valueStyles}>{loading ? <Skeleton width="5rem" height="1.0625rem" /> : value}</div>
      <div className={labelStyles}>
        {icon} {label}
      </div>
    </div>
  );
};
